import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-3 mb-2" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "display-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      class: "display-1 mb-3 mb-md-4",
      innerHTML: _ctx.title
    }, null, 8, _hoisted_2),
    _createElementVNode("img", {
      alt: _ctx.title,
      src: _ctx.imgSrc,
      class: "img-fluid mb-3"
    }, null, 8, _hoisted_3),
    _createElementVNode("h2", _hoisted_4, [
      _renderSlot(_ctx.$slots, "intro")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}